/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// Illegal or awkward in filenames across common filesystems.
const ILLEGAL_FILENAME_CHARS = /[/\\:*?"<>|]/g;

const sanitizeModelName = modelName =>
  String(modelName == null ? '' : modelName)
    .replace(ILLEGAL_FILENAME_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^[\s.]+|[\s.]+$/g, '');

const buildDownloadFilename = (modelName, name, extension) => {
  const sanitized = sanitizeModelName(modelName);
  return sanitized ? `${sanitized} - ${name}.${extension}` : `${name}.${extension}`;
};

export default buildDownloadFilename;
